import { getValueFromToken } from './getValueFromToken';

export const hasOnlyRMAccess = () => {
  return getValueFromToken('hasOnlyRMAccess');
};
